module.exports = __webpack_public_path__ + "56d9d42e23863ce0ee8e8c2e2f22843f.eot";


//////////////////
// WEBPACK FOOTER
// ./~/clarity-ui/dist/fonts/open-sans-extrabold.eot
// module id = 671
// module chunks = 0